import * as React from 'react'
import { Button, Form, Image } from 'react-bootstrap'
import _ from 'lodash'
import {  uploadFileServer } from '../../redux/actions'
import config from '../../constants/config'

import { stateFromAddress } from '../../utils/stateFromAddress'


import Colorado from './Colorado/Colorado'
import Texas from './Texas/Texas'
import { CompanyT, companyObj, OptionsWorkerPay } from '../../types/Company'
import { copyObject } from '../../utils'
import ButtonLoading from '../../components/ButtonLoading/ButtonLoading'
import images from '../../constants/images'
import ButtonUploadImage from '../../components/ButtonUploadImage'
import InputPhone from '../../components/InputPhone'

import AudioRecorder from '../../components/AudioRecorder'
import NumberFormatValidate from '../../components/NumberFormatValidate'
import { OptionsJobType } from '../jobs/NewJob/OptionsFieldsJob'
import { Box } from '@mui/material'
import { AxiosInstance } from '../../utils/RequestMethods'
import GoogleMapAutoComplete from '../../components/MapBoxAutoComplete/GoogleMapAutoComplete'




const CompanyObj = {
    id: -1,
    address: '',
    state: ''
}

interface CompanyTabProps {
    company: CompanyT
    updateCompany(company: CompanyT): void
}

const CompanyTab: React.FunctionComponent<CompanyTabProps> = ({ company, updateCompany }): JSX.Element => {
    const [currentCompany, setCurrentCompany] = React.useState(companyObj)
    const [dirty, setDirty] = React.useState({})
    const [fileLogo, setFileLogo] = React.useState(null)
    const [fileVoiceMail, setFileVoiceMail] = React.useState(null)
    const [uriVoicemail, seturiVoicemail] = React.useState(null)
    const [showRecordAudio, setShowRecordAudio] = React.useState(false)
    const audioRef = React.useRef(null)
    React.useEffect(() => {
        setCurrentCompany(company)
    }, [company])



    const submitSaveCompany = async (params = null): Promise<string> => {
        if (!params) {
            params = { ...dirty }
        }
        console.log('params', params)
        console.log('params', dirty)
        return await saveCompany(params)
    }



    const saveCompany = async (params): Promise<string> => {
        if (!params) {
            params = {}
        }

        try {
            let res = await AxiosInstance.post(`${config.url.companies}/${company.id}`, params)
            if (res && res.data) {
                console.log(company, res)
                setDirty({})
                updateCompany(res.data)
                return 'Company saved.'
            }
        } catch (error) {

            throw new Error(error)

        }
    }

    const updateItemCompany = (key, value): void => {
        let cloneCompany = copyObject(company)
        cloneCompany[key] = value
        updateCompany(copyObject(cloneCompany))
    }

    const stateRequirements = (): JSX.Element => {
        let titleBase = 'Required Information'

        switch (company.addressState) {
            case 'Colorado':
                return <Colorado
                    company={company}
                    // stateMeta={dirty && dirty['stateMeta'] ? dirty['stateMeta'] : company.stateMeta }
                    stateTitle={'Colorado ' + titleBase}
                    updateStateMeta={(value) => {
                        //console.log("pucNumber->we", pucNumber)
                        let cloneDirty = copyObject(dirty)
                        if (cloneDirty['stateMeta'] && cloneDirty['stateMeta']['Colorado']) {
                            cloneDirty['stateMeta']['Colorado'] = value
                        } else {
                            cloneDirty['stateMeta'] = {
                                Colorado: value
                            }
                        }

                        setDirty(cloneDirty)
                        // updateDirty('addressState', company.addressState)
                        // updateDirty('pucNumber', pucNumber)

                    }}
                />
            case 'Texas':
                return <Texas />
            default:
                return null
        }
    }

    const updateDirty = (key: string, value: any): void => {
        let cloneDirty = copyObject(dirty)
        cloneDirty[key] = value
        setDirty(cloneDirty)
    }

    const saveCompanyLogo = async (event): Promise<string> => {
        try {
            const res = await uploadFileServer(fileLogo)
            if (res.source_url) {
                //updateDirty('profilePic', res.source_url)
                let params = {
                    logo: res.source_url
                }
                const resSave = await saveCompany(params)
                if (resSave) {
                    setTimeout(() => {
                        setFileLogo(null)
                    }, 1000);
                    return "Profile Pic saved."
                }
            }
        } catch (error) {
            throw new Error(error)
        }
    }


    const updateFilesCompany = async (key: string, file: any): Promise<string> => {
        try {
            const res = await uploadFileServer(file)
            if (res.source_url) {
                //updateDirty('profilePic', res.source_url)
                let params = {
                    logo: res.source_url
                }
                params[key] = res.source_url
                const resSave = await saveCompany(params)
                return resSave;
                // if (resSave) {
                //     setTimeout(() => {
                //         setFileLogo(null)
                //     }, 1000);
                //     //return "Profile Pic saved."
                //     return "true";
                // }
            }
        } catch (error) {
            throw new Error(error)
        }
    }

    const reloadAudio = () => {
        setTimeout(() => {
            if (audioRef.current) {
                audioRef.current.load();
            }
        }, 100);
    }
    // console.log("company", company)
    // console.log(" dirty['smuvsPhone']", dirty && dirty['smuvsPhone'] ? dirty['smuvsPhone'] : "ee")
    return (
        <Box height="100%">
            <div style={{}}>
                <div>
                    <Image
                        style={{ width: 200, height: 200 }}
                        src={fileLogo && fileLogo.uri ? fileLogo.uri : company.logo ? company.logo : images.noProfilePic} />
                </div>
                <div>
                    <ButtonUploadImage
                        type="button"
                        //default={false}
                        accept={"image/png, image/jpeg"}
                        className="btn-link  mt-2"
                        onChangeFile={async (file) => {
                            setFileLogo(file)

                            // const res = await uploadFileServer(file)
                            // if (res.source_url) {
                            //     let cloneDirty = copyObject(dirty)
                            //     cloneDirty['logo'] = res.source_url
                            //     setDirty(cloneDirty)
                            // }
                        }}>Upload Company Logo</ButtonUploadImage>
                    {fileLogo && <div>
                        <Button variant="light" onClick={() => { setFileLogo(null) }}> Cancel</Button>
                        <ButtonLoading
                            className="btn-primary"
                            onClickFetching={async (e): Promise<string> => {
                                try {
                                    let res = await updateFilesCompany("logo", fileLogo)
                                    if (res) {
                                        setTimeout(() => {
                                            setFileLogo(null)
                                        }, 1000);
                                        return "Profile Pic saved."
                                    }
                                } catch (error) {
                                    throw new Error(error)
                                }

                            }}>
                            Save</ButtonLoading>
                    </div>}
                </div>
            </div>
            <Form.Label>Company Name</Form.Label>
            <Form.Control
                className='input-material'
                value={`${_.has(dirty, "name") ? dirty['name'] : company.name}`}
                onChange={(event) => {
                    updateDirty('name', event.target.value)
                }}
            />
            <Form.Group controlId="companyEmail">
                <Form.Label>Company Email</Form.Label>
                <Form.Control
                    className='input-material'
                    value={`${_.has(dirty, "email") ? dirty['email'] : company.email}`}
                    onChange={(event) => {
                        updateDirty('email', event.target.value)
                    }}
                />
            </Form.Group>
            <Form.Group controlId="companyPhone">
                <Form.Label>Company Phone</Form.Label>
                <InputPhone
                    className="input-material"
                    defaultValue={`${_.has(dirty, "phone") ? dirty['phone'] : company.phone}`}
                    value={`${_.has(dirty, "phone") ? dirty['phone'] : company.phone}`}
                    onChangeValue={val => { updateDirty('phone', val) }} />

            </Form.Group>
            <Form.Group controlId="smuvsPhone">
                <Form.Label>MoveSheet Phone</Form.Label>
                <InputPhone
                    className="input-material"
                    defaultValue={`${_.has(dirty, "smuvsPhone") ? dirty['smuvsPhone'] : company.smuvsPhone}`}
                    value={`${_.has(dirty, "smuvsPhone") ? dirty['smuvsPhone'] : company.smuvsPhone}`}
                    onChangeValue={val => { updateDirty('smuvsPhone', val) }} />

            </Form.Group>
            <Form.Label>Primary Address</Form.Label>
            <GoogleMapAutoComplete
                idAddresss="address"
                className='input-material'
                apiKey={config.keyMap}
                onChangeText={text => { }}
                onPress={async location => {
                    let s = await stateFromAddress(config.keyMapBox, location.verbose_address, true)
                    console.log("addressState", s)
                    let cloneDirty = copyObject(dirty)
                    cloneDirty['address'] = location.verbose_address
                    cloneDirty['addressState'] = s
                    setDirty(cloneDirty)

                    let cloneCompany = copyObject(company)
                    cloneCompany.address = location.verbose_address
                    cloneCompany.addressState = s
                    updateCompany(cloneCompany)
                }}
                placeholder=''
                textValue={company.address} />
            <Form.Label>Unit</Form.Label>
            <Form.Control
                value={_.has(dirty, "unit") ? dirty['unit'] : company.unit}
                className='input-material'
                onChange={(event: any) => {
                    updateDirty('unit', event.target.value)
                }} />

            <Form.Label>Standard Crew Size</Form.Label>
            <Form.Control
                as='select'
                className='input-material'
                value={_.has(dirty, "standardCrewSize") ? dirty['standardCrewSize'] : company.standardCrewSize}
                onChange={(event: any) => {
                    updateDirty('standardCrewSize', event.target.value)
                }}
            >
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
            </Form.Control>


            <Form.Label >Default Job Type</Form.Label>
            <Form.Control
                as='select'
                className='input-material'
                value={_.has(dirty, "defaultJobType") ? dirty['defaultJobType'] : company.defaultJobType}
                onChange={(event: any) => { updateDirty('defaultJobType', event.target.value) }}>
                {Object.keys(OptionsJobType).map((key, index) => {
                    return (
                        <option value={key} key={index}>{OptionsJobType[key]}</option>
                    )
                })}

            </Form.Control>

            <Form.Label >Default Worker Pay Type</Form.Label>
            <Form.Control
                as='select'
                className='input-material'
                value={_.has(dirty, "defaultWorkerPay") ? dirty['defaultWorkerPay'] : company.defaultWorkerPay}
                onChange={(event: any) => { updateDirty('defaultWorkerPay', event.target.value) }}>
                {Object.keys(OptionsWorkerPay).map((key, index) => {
                    return (
                        <option value={key} key={index}>{OptionsWorkerPay[key]}</option>
                    )
                })}

            </Form.Control>
            <Form.Group controlId="companyhandle">
                <Form.Label>Company Handle</Form.Label>
                <Form.Control
                    className='input-material'
                    value={`${_.has(dirty, "handle") ? dirty['handle'] : company.handle}`}
                    onChange={(event) => {
                        updateDirty('handle', event.target.value)
                    }}
                />
            </Form.Group>
            {stateRequirements()}
            <Form.Group>
                <Form.Label >VoiceMail</Form.Label>

                {(uriVoicemail || (company.voicemail && company.voicemail != "")) && <div> <audio controls ref={audioRef}>
                    <source type="audio/mp3" src={`${uriVoicemail ? uriVoicemail : company.voicemail}`} />
                </audio></div>}
                {!showRecordAudio && <div>
                    <button type="button" className="btn btn-primary  mt-2" onClick={(event) => { setShowRecordAudio(true) }}>{`${company.voicemail ? "Change" : "Create"}`} VoiceMail</button></div>}
                {showRecordAudio && <AudioRecorder onUriAvailable={(uri) => {
                    seturiVoicemail(uri)
                    reloadAudio()

                }}
                    onFileAvailable={async (file) => { setFileVoiceMail(file) }} />}
                {fileVoiceMail && <div>
                    <Button variant="light"
                        onClick={() => {
                            setFileVoiceMail(null)
                            seturiVoicemail(null)
                            setShowRecordAudio(false)
                            reloadAudio()
                        }}>Cancel</Button>
                    <ButtonLoading
                        className="btn-primary"
                        onClickFetching={async (e): Promise<string> => {
                            try {
                                let res = await updateFilesCompany("voicemail", fileVoiceMail)
                                if (res) {
                                    setTimeout(() => {
                                        setFileVoiceMail(null)
                                        setShowRecordAudio(false)
                                    }, 1000);
                                    return "VoiceMail saved."
                                }
                            } catch (error) {
                                throw new Error(error)
                            }

                        }}>
                        Save</ButtonLoading>
                </div>}
            </Form.Group>
            <Form.Label>Maximum Voicemail Length, seconds</Form.Label>
            {/* https://www.twilio.com/docs/voice/twiml/record#attributes-maxlength */}
            <NumberFormatValidate
                customInput={Form.Control}
                type="text"
                className="input-material"
                defaultValue={_.has(dirty, "recordingMaxLength") ? dirty['recordingMaxLength'] : company.recordingMaxLength}
                value={_.has(dirty, "recordingMaxLength") ? dirty['recordingMaxLength'] : company.recordingMaxLength}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    updateDirty('recordingMaxLength', formattedValue)
                }}
                // isAllowed={(values) => {
                //     const { formattedValue, value, floatValue } = values;
                //     return value >= 0 || value <= 100
                // }}
                placeholder=""
            // mask="_"
            />
            {/* <Form.Row> */}

            <Form.Group>
                <Form.Label>Show Documents</Form.Label>
                <Form.Check
                    // id="custom-switch"
                    // custom
                    className='mt-2'
                    id={`${"custom-"}showDocuments`}
                    checked={_.has(dirty, "showDocuments") ? dirty['showDocuments'] : company.showDocuments == true ? true : false}
                    type="checkbox"
                    onChange={(event) => {
                        let isChecked = _.has(dirty, "showDocuments") ? dirty['showDocuments'] : company.showDocuments == true ? true : false
                        updateDirty('showDocuments', !isChecked)
                        // onChangeFields("showDocuments", !dirty.showDocuments)

                    }}

                    label={'Show Documents'}
                />

            </Form.Group>
            {/* </Form.Row> */}
            <ButtonLoading
                className="btn-primary"
                variant="success"
                onClickFetching={async (e): Promise<string> => {
                    return await submitSaveCompany()
                }}>
                Save
            </ButtonLoading>


        </Box>
    )
}

export default CompanyTab
